"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isMiscProduct = exports.isMeatProduct = exports.isFishProduct = exports.isGeneralRetailProduct = exports.isRetailProduct = exports.isInvokeGetSingleProductEvent = exports.ProductIdType = exports.MasterProductType = exports.RetailProductProperty = exports.GeneralRetailProductProperty = exports.MiscProductProductionMethod = exports.MiscProductType = exports.ProductTags = exports.PackageUnit = void 0;
/** Default package units */
var PackageUnit;
(function (PackageUnit) {
    PackageUnit["g"] = "g";
    PackageUnit["kg"] = "kg";
    PackageUnit["ml"] = "ml";
    PackageUnit["cl"] = "cl";
    PackageUnit["dl"] = "dl";
    PackageUnit["l"] = "l";
    PackageUnit["m"] = "m";
    PackageUnit["kpl"] = "kpl";
    PackageUnit["ras"] = "ras";
    PackageUnit["tbl"] = "tbl";
    PackageUnit["plo"] = "plo";
    PackageUnit["tlk"] = "tlk";
    PackageUnit["pss"] = "pss";
    PackageUnit["nip"] = "nip";
})(PackageUnit = exports.PackageUnit || (exports.PackageUnit = {}));
var ProductTags;
(function (ProductTags) {
    ProductTags["organic"] = "organic";
    ProductTags["local"] = "local";
    ProductTags["discount"] = "discount";
    ProductTags["new"] = "new";
    // bonus = 'bonus'
})(ProductTags = exports.ProductTags || (exports.ProductTags = {}));
var MiscProductType;
(function (MiscProductType) {
    MiscProductType["fish"] = "fish";
    MiscProductType["meat"] = "meat";
})(MiscProductType = exports.MiscProductType || (exports.MiscProductType = {}));
var MiscProductProductionMethod;
(function (MiscProductProductionMethod) {
    MiscProductProductionMethod["farmed"] = "farmed";
    MiscProductProductionMethod["catched"] = "catched";
})(MiscProductProductionMethod = exports.MiscProductProductionMethod || (exports.MiscProductProductionMethod = {}));
/** Properties used in GeneralRetailProduct */
var GeneralRetailProductProperty;
(function (GeneralRetailProductProperty) {
    GeneralRetailProductProperty["productId"] = "productId";
    GeneralRetailProductProperty["customerId"] = "customerId";
    GeneralRetailProductProperty["createdAt"] = "createdAt";
    GeneralRetailProductProperty["comparisonString"] = "comparisonString";
    GeneralRetailProductProperty["comparisonUnit"] = "comparisonUnit";
    GeneralRetailProductProperty["deposit"] = "deposit";
    GeneralRetailProductProperty["description"] = "description";
    GeneralRetailProductProperty["discount"] = "discount";
    GeneralRetailProductProperty["discountPrice"] = "discountPrice";
    GeneralRetailProductProperty["discountBatchSize"] = "discountBatchSize";
    GeneralRetailProductProperty["discountValidString"] = "discountValidString";
    GeneralRetailProductProperty["key"] = "key";
    GeneralRetailProductProperty["name"] = "name";
    GeneralRetailProductProperty["packageSize"] = "packageSize";
    GeneralRetailProductProperty["packageUnit"] = "packageUnit";
    GeneralRetailProductProperty["price"] = "price";
    GeneralRetailProductProperty["unit"] = "unit";
    GeneralRetailProductProperty["updatedAt"] = "updatedAt";
})(GeneralRetailProductProperty = exports.GeneralRetailProductProperty || (exports.GeneralRetailProductProperty = {}));
/** Properties used in RetailProducts */
var RetailProductProperty;
(function (RetailProductProperty) {
    RetailProductProperty["productId"] = "productId";
    RetailProductProperty["createdAt"] = "createdAt";
    RetailProductProperty["updatedAt"] = "updatedAt";
    RetailProductProperty["approxPrice"] = "approxPrice";
    RetailProductProperty["approxPriceUnit"] = "approxPriceUnit";
    RetailProductProperty["brand"] = "brand";
    RetailProductProperty["comparisonUnit"] = "comparisonUnit";
    RetailProductProperty["comparisonString"] = "comparisonString";
    RetailProductProperty["country"] = "country";
    RetailProductProperty["customId"] = "customId";
    RetailProductProperty["dairyFree"] = "dairyFree";
    RetailProductProperty["deposit"] = "deposit";
    RetailProductProperty["description"] = "description";
    RetailProductProperty["discount"] = "discount";
    RetailProductProperty["discountBatchSize"] = "discountBatchSize";
    RetailProductProperty["discountBatchUnit"] = "discountBatchUnit";
    RetailProductProperty["discountEndDate"] = "discountEndDate";
    RetailProductProperty["discountPercentage"] = "discountPercentage";
    RetailProductProperty["discountPrice"] = "discountPrice";
    RetailProductProperty["discountStartDate"] = "discountStartDate";
    RetailProductProperty["discountType"] = "discountType";
    RetailProductProperty["discountTypeCode"] = "discountTypeCode";
    RetailProductProperty["discountUnitPrice"] = "discountUnitPrice";
    RetailProductProperty["discountValidString"] = "discountValidString";
    RetailProductProperty["freeText"] = "freeText";
    RetailProductProperty["glutenFree"] = "glutenFree";
    RetailProductProperty["group"] = "group";
    RetailProductProperty["imageUrl"] = "imageUrl";
    RetailProductProperty["lactoseFree"] = "lactoseFree";
    RetailProductProperty["layout"] = "layout";
    RetailProductProperty["lowLactose"] = "lowLactose";
    RetailProductProperty["loyaltyCustomerPrice"] = "loyaltyCustomerPrice";
    RetailProductProperty["loyaltyCustomerPriceVisible"] = "loyaltyCustomerPriceVisible";
    RetailProductProperty["name"] = "name";
    RetailProductProperty["packageSize"] = "packageSize";
    RetailProductProperty["packageUnit"] = "packageUnit";
    RetailProductProperty["price"] = "price";
    RetailProductProperty["qrCodeUrl"] = "qrCodeUrl";
    RetailProductProperty["qualityClass"] = "qualityClass";
    RetailProductProperty["scaleNumber"] = "scaleNumber";
    RetailProductProperty["stock"] = "stock";
    RetailProductProperty["strength"] = "strength";
    RetailProductProperty["supplier"] = "supplier";
    RetailProductProperty["unit"] = "unit";
    RetailProductProperty["unitPrice"] = "unitPrice";
    RetailProductProperty["unitPriceUnit"] = "unitPriceUnit";
    RetailProductProperty["vegan"] = "vegan";
    RetailProductProperty["vegetarian"] = "vegetarian";
})(RetailProductProperty = exports.RetailProductProperty || (exports.RetailProductProperty = {}));
/**
 * Type of MasterProduct. Used in chain integrations.
 * Currently only pharmacy supported.
 */
var MasterProductType;
(function (MasterProductType) {
    MasterProductType["pharmacy"] = "pharmacy";
})(MasterProductType = exports.MasterProductType || (exports.MasterProductType = {}));
/**
 * Type of productId. Used e.g when fetching MasterProduct for a pharmacy campaign
 */
var ProductIdType;
(function (ProductIdType) {
    ProductIdType["ean"] = "ean";
    ProductIdType["vnr"] = "vnr";
})(ProductIdType = exports.ProductIdType || (exports.ProductIdType = {}));
exports.isInvokeGetSingleProductEvent = (event) => typeof event.productId === 'string';
/** Typeguards for products */
exports.isRetailProduct = (product) => (product === null || product === void 0 ? void 0 : product.productId) && !(product === null || product === void 0 ? void 0 : product.customerId) && !product.itemId; // note: pricer plaza products have itemId
/** General retail product has productId and customerId, but not productType property */
exports.isGeneralRetailProduct = (product) => (product === null || product === void 0 ? void 0 : product.productId) && (product === null || product === void 0 ? void 0 : product.customerId) && !product.productType;
exports.isFishProduct = (product) => (product === null || product === void 0 ? void 0 : product.productType) === MiscProductType.fish;
exports.isMeatProduct = (product) => (product === null || product === void 0 ? void 0 : product.productType) === MiscProductType.meat;
exports.isMiscProduct = (product) => exports.isFishProduct(product) || exports.isMeatProduct(product);
//# sourceMappingURL=products.js.map